import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { clinic } from "@/mocks/clinic";
import { recruitEntry } from "@/mocks/legalPages";

/**
 * 採用ページ ENTRY。
 * 正式な応募フォームURL・採用専用メールアドレスが未設定のため、存在しない応募先は作らない。
 * LINEは仮URLのため使用せず、電話CTAのみを設置する。
 */
export default function RecruitEntry() {
  return (
    <section className="border-t border-background-300/70 bg-background-100 py-20 md:py-28 lg:py-32">
      <div className="u-container">
        <Reveal>
          <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between md:gap-16">
            <div>
              <SectionHeading en={recruitEntry.en} jp={recruitEntry.heading} />
              <div className="mt-8 max-w-xl space-y-4">
                {recruitEntry.paragraphs.map((paragraph) => (
                  <p key={paragraph} className="text-[13px] leading-[2.2] text-foreground-700 md:text-sm">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>

            <a
              href={clinic.telHref}
              className="inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-md bg-primary-600 px-8 py-4 text-[14px] font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-phone-line text-base" aria-hidden />
              採用について問い合わせる
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}